import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { merge } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import dayjs from 'dayjs';
import { MatInputModule } from '@angular/material/input';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';
import { ZohoBooksFeatureService, ZohoGroupByDateTypes } from '../../../../../features/zoho-books-feature/zoho-books-feature.service';

const moment = _rollupMoment || _moment;
moment.updateLocale(moment.locale(), { week: { dow: 1, doy: 4 } });

const DATE_FORMATS = {
  parse: { dateInput: 'DD/MM/YYYY' },
  display: { dateInput: 'DD/MM/YYYY', monthYearLabel: 'MMM YYYY', dateA11yLabel: 'LL', monthYearA11yLabel: 'MMMM YYYY' },
};

@Component({
  selector: 'app-zoho-books-filters',
  standalone: true,
  imports: [
    MatCardModule,
    MatFormFieldModule,
    MatDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonToggleModule,
    MatButton,
    MatIconModule,
    DecimalPipe,
  ],
  providers: [provideMomentDateAdapter(DATE_FORMATS)],
  templateUrl: './zoho-books-filters.component.html',
  styleUrl: './zoho-books-filters.component.css',
})
export class ZohoBooksFiltersComponent implements OnInit {
  _zohoBooksFeature = inject(ZohoBooksFeatureService);

  @Output() dateFilterChanged = new EventEmitter<void>();

  readonly dateInput = new FormControl(moment(this._zohoBooksFeature.selectedDate().toDate()));
  readonly groupByDateTypeInput = new FormControl<ZohoGroupByDateTypes>(this._zohoBooksFeature.groupByDateTypes());
  readonly searchControl = new FormControl<string>(this._zohoBooksFeature.searchText());

  constructor() {
    merge(this.dateInput.statusChanges, this.dateInput.valueChanges)
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.updateDateFilter());

    merge(this.groupByDateTypeInput.statusChanges, this.groupByDateTypeInput.valueChanges)
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.updateGroupByDateType());

    this.searchControl.valueChanges
      .pipe(takeUntilDestroyed())
      .subscribe((value) => this._zohoBooksFeature.searchText.set(value ?? ''));
  }

  ngOnInit() {}

  updateDateFilter() {
    if (!this.dateInput.value) return;
    const date = this.dateInput.value.toDate();
    this._zohoBooksFeature.selectedDate.set(dayjs(date));
    this.dateFilterChanged.emit();
  }

  updateGroupByDateType() {
    this._zohoBooksFeature.groupByDateTypes.set(this.groupByDateTypeInput?.value ?? 'day');
    this.dateFilterChanged.emit();
  }

  resetFilters() {
    this.dateInput.patchValue(moment());
    this.groupByDateTypeInput.patchValue('day');
    this.searchControl.setValue('');
  }
}
